import type { QueryClient } from "@tanstack/react-query";

import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";

export interface UnreadNotificationsCount {
  count: number;
}

export function getUnreadNotificationsStorageKey(userId: string) {
  return `garimpa:notifications:unread-count:${userId}`;
}

export function getUnreadNotificationsCountQueryOptions() {
  return {
    ...orpc.notifications.getUnreadCount.queryOptions({}),
    staleTime: QUERY_STALE_TIMES.unreadCount,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  };
}

export function decrementUnreadNotificationsCount(queryClient: QueryClient) {
  queryClient.setQueryData<UnreadNotificationsCount>(
    getUnreadNotificationsCountQueryOptions().queryKey,
    (current) => ({ count: Math.max((current?.count ?? 0) - 1, 0) }),
  );
}

export function clearUnreadNotificationsCount(queryClient: QueryClient) {
  queryClient.setQueryData<UnreadNotificationsCount>(
    getUnreadNotificationsCountQueryOptions().queryKey,
    { count: 0 },
  );
}
